var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

var HistoricalDevices = function (_Component) {
    _inherits(HistoricalDevices, _Component);

    function HistoricalDevices(props) {
        _classCallCheck(this, HistoricalDevices);

        var _this = _possibleConstructorReturn(this, (HistoricalDevices.__proto__ || Object.getPrototypeOf(HistoricalDevices)).call(this, props));

        _this.handleOnClick = function () {
            if (!_this.state.isOpen) {
                setTimeout(function () {
                    if (_this.props.checkIsExpandedContentDevice !== undefined) {

                        _this.props.checkIsExpandedContentDevice();
                    }
                }, 100);
                _this.setState({
                    isOpen: !_this.state.isOpen
                });
            } else {
                setTimeout(function () {
                    if (_this.props.checkIsExpandedContentDevice !== undefined) {

                        _this.props.checkIsExpandedContentDevice();
                    }
                }, 500);
                _this.setState({
                    isOpen: !_this.state.isOpen
                });
            }
        };

        _this.handleOnClickStop = function (dataStop, i) {
            _this.props.createMarkerHistoricalStopsIndividually(dataStop);
            _this.props.showStopIndividually(dataStop, i);
            _this.props.isHistoricalInfoDeviceOpen();
        };

        _this.state = {
            stateClass: '',
            stateIconClass: '',
            label: '',
            isOpen: false,
            historicalData: '',
            listHistoricalData: []
        };
        return _this;
    }

    _createClass(HistoricalDevices, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var t = this.props.t;
            // let classNameCollapse = "";

            // if (this.props.expandedDevice !== undefined) {
            //     if (this.props.expandedDevice) {
            //         classNameCollapse = "collapse show"
            //     } else {
            //         classNameCollapse = "collapse"
            //     }
            // }

            return React.createElement(
                'div',
                { className: 'panel-body', id: 'accordion1' },
                React.createElement(
                    'div',
                    { className: 'panel-group' },
                    React.createElement(
                        'div',
                        { className: 'panel panel-default sub-group-content sub-group-1' },
                        React.createElement(
                            'div',
                            { id: 'location-detail-7', className: 'location-detail-box location-detail-7 panel panel-default' },
                            this.props.children[2],
                            React.createElement(
                                'a',
                                { 'data-toggle': 'collapse', 'data-parent': '#accordion'
                                    // onClick={this.handleOnClick.bind(this)} 
                                },
                                React.createElement(
                                    'div',
                                    { className: 'panel-heading map-content-level2' },
                                    React.createElement(
                                        'div',
                                        { className: 'panel-title' },
                                        React.createElement(
                                            'div',
                                            { className: 'level2-heading' },
                                            React.createElement(
                                                'div',
                                                { className: 'level2-heading-left' },
                                                React.createElement('span', { className: "bg-left " + this.state.stateClass }),
                                                React.createElement('span', { className: this.state.stateIconClass }),
                                                React.createElement(
                                                    'span',
                                                    { className: 'trackerName' },
                                                    this.props.device.assetsInfoName
                                                )
                                            ),
                                            React.createElement(
                                                'div',
                                                { className: 'level2-heading-right' },
                                                React.createElement(
                                                    'ul',
                                                    { className: 'list-unstyled list-addons' },
                                                    this.props.children[0],
                                                    this.props.children[1]
                                                )
                                            )
                                        )
                                    )
                                )
                            ),
                            React.createElement(
                                'div',
                                { className: 'collapse show', id: 'popUpHistoricalDevice' },
                                React.createElement(
                                    'div',
                                    { className: 'panel-body level2-content' },
                                    React.createElement(
                                        'div',
                                        { className: 'level2-content-top', style: { paddingLeft: "22px", paddingRight: "22px" } },
                                        React.createElement(
                                            'div',
                                            { className: 'level2-content-top-inner clearfix' },
                                            React.createElement(
                                                'div',
                                                { id: 'trip-view-content', style: { lineHeight: "1.42857143" } },
                                                React.createElement(
                                                    'div',
                                                    { className: 'trip-view-content-top clearfix', style: { marginBottom: "5px" } },
                                                    React.createElement(
                                                        'div',
                                                        { style: { marginLeft: "5px", width: "100%" } },
                                                        React.createElement(
                                                            'div',
                                                            { className: 'trip-view-content-top-box' },
                                                            React.createElement(
                                                                'div',
                                                                { className: 'trip-box-top clearfix' },
                                                                React.createElement('span', { className: 'icon-steering_wheel' }),
                                                                React.createElement(
                                                                    'h4',
                                                                    null,
                                                                    t("map.sidebar.devicesContent.historicalDevices.driving")
                                                                )
                                                            ),
                                                            React.createElement(
                                                                'div',
                                                                { className: 'trip-box-bottom' },
                                                                this.state.historicalData.drivingTime === "" ? "00:00" : this.state.historicalData.drivingTime,
                                                                React.createElement('span', null)
                                                            )
                                                        ),
                                                        React.createElement(
                                                            'div',
                                                            { className: 'trip-view-content-top-box' },
                                                            React.createElement(
                                                                'div',
                                                                { className: 'trip-box-top clearfix' },
                                                                React.createElement('span', { className: 'icon-road_red' }),
                                                                React.createElement(
                                                                    'h4',
                                                                    null,
                                                                    t("map.sidebar.devicesContent.historicalDevices.distance")
                                                                )
                                                            ),
                                                            React.createElement(
                                                                'div',
                                                                { className: 'trip-box-bottom' },
                                                                this.state.historicalData.distanceTravelled,
                                                                React.createElement(
                                                                    'span',
                                                                    null,
                                                                    'KM'
                                                                )
                                                            )
                                                        ),
                                                        React.createElement(
                                                            'div',
                                                            { className: 'trip-view-content-top-box' },
                                                            React.createElement(
                                                                'div',
                                                                { className: 'trip-box-top clearfix' },
                                                                React.createElement('span', { className: 'icon-stop_sign' }),
                                                                React.createElement(
                                                                    'h4',
                                                                    null,
                                                                    t("map.sidebar.devicesContent.historicalDevices.stops")
                                                                )
                                                            ),
                                                            React.createElement(
                                                                'div',
                                                                { className: 'trip-box-bottom' },
                                                                this.state.listHistoricalData.length,
                                                                React.createElement(
                                                                    'span',
                                                                    null,
                                                                    'p'
                                                                ),
                                                                React.createElement(
                                                                    'span',
                                                                    null,
                                                                    this.state.historicalData.stopTime,
                                                                    React.createElement('span', null)
                                                                )
                                                            )
                                                        ),
                                                        React.createElement(
                                                            'div',
                                                            { className: 'trip-view-content-top-box' },
                                                            React.createElement(
                                                                'div',
                                                                { className: 'trip-box-top clearfix' },
                                                                React.createElement('span', { className: 'icon-euro_money_red' }),
                                                                React.createElement(
                                                                    'h4',
                                                                    null,
                                                                    t("map.sidebar.devicesContent.historicalDevices.fuelConsuption")
                                                                )
                                                            ),
                                                            React.createElement(
                                                                'div',
                                                                { className: 'trip-box-bottom' },
                                                                this.state.historicalData.fuelConsumption,
                                                                React.createElement(
                                                                    'span',
                                                                    { className: 'Letters' },
                                                                    'L'
                                                                )
                                                            )
                                                        )
                                                    )
                                                ),
                                                React.createElement(
                                                    'div',
                                                    { className: 'trip-view-content-bottom', style: { background: "#fff", margin: "auto", marginBottom: "5px", width: "100%", height: "200px", overflow: "scroll" } },
                                                    this.state.listHistoricalData.map(function (item, i) {
                                                        return React.createElement(
                                                            'div',
                                                            { key: i, className: 'trip-bottom-item clearfix', onClick: _this2.handleOnClickStop.bind(_this2, item, i), style: { marginTop: "3px", height: "35px" } },
                                                            React.createElement(
                                                                'div',
                                                                { className: "trip-bottom-item-number " + item.styleClass },
                                                                i + 1
                                                            ),
                                                            React.createElement(
                                                                'div',
                                                                { className: 'trip-bottom-item-middle' },
                                                                React.createElement(
                                                                    'span',
                                                                    { className: 'trip-bottom-item-time' },
                                                                    item.startTime[0]
                                                                ),
                                                                React.createElement(
                                                                    'span',
                                                                    { className: 'trip-bottom-item-content' },
                                                                    item.address
                                                                )
                                                            ),
                                                            React.createElement(
                                                                'div',
                                                                { className: 'trip-bottom-item-last' },
                                                                React.createElement(
                                                                    'span',
                                                                    { className: 'trip-bottom-item-duration' },
                                                                    React.createElement('span', {
                                                                        className: 'icon-chrono' }),
                                                                    React.createElement(
                                                                        'span',
                                                                        null,
                                                                        item.duration,
                                                                        React.createElement(
                                                                            'span',
                                                                            null,
                                                                            'h'
                                                                        )
                                                                    )
                                                                )
                                                            )
                                                        );
                                                    })
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }], [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(props, state) {
            var _ref = '',
                stateClass = _ref.stateClass,
                stateIconClass = _ref.stateIconClass,
                label = _ref.label,
                historicalData = _ref.historicalData,
                listHistoricalData = _ref.listHistoricalData;
            var t = props.t;

            if (props.device !== undefined) {
                if (props.device.assetsIOTInfo !== undefined) {
                    if (props.device.assetsIOTInfo[0].gpsInfo.speed >= 5) {
                        stateClass = 'map-green-bg';
                        stateIconClass = 'icon-road2';
                        label = t("map.sidebar.filtersDevices.driving");
                    }
                    if (props.device.assetsIOTInfo[0].gpsInfo.speed >= 1 && props.device.assetsIOTInfo[0].gpsInfo.speed < 5) {
                        stateClass = 'map-yellow-bg';
                        stateIconClass = 'icon-stop_sign';
                        label = t("map.sidebar.filtersDevices.stop");
                    }
                    if (props.device.assetsIOTInfo[0].gpsInfo.speed <= 0) {
                        stateClass = 'map-red-bg';
                        stateIconClass = 'icon-parking';
                        label = t("map.sidebar.filtersDevices.parked");
                    }
                    var noGprs = props.transformDateAndCompare(props.device.assetsIOTInfo[0].gpsInfo.timestampApi);
                    if (noGprs) {
                        stateClass = 'map-blue-bg';
                        stateIconClass = 'icon-no_gprs';
                        label = t("map.sidebar.filtersDevices.noGprs");
                    }
                    // if (props.device.assetsIOTInfo[0].gpsInfo.speed === undefined) {
                    //     stateClass = 'map-blue-bg'
                    //     stateIconClass = 'icon-no_gprs'
                    //     label = 'No-GPRS'
                    // }
                } else {
                    if (props.device.gpsInfo.speed >= 5) {
                        stateClass = 'map-green-bg';
                        stateIconClass = 'icon-road2';
                        label = t("map.sidebar.filtersDevices.driving");
                    }
                    if (props.device.gpsInfo.speed >= 1 && props.device.gpsInfo.speed < 5) {
                        stateClass = 'map-yellow-bg';
                        stateIconClass = 'icon-stop_sign';
                        label = t("map.sidebar.filtersDevices.stop");
                    }
                    if (props.device.gpsInfo.speed <= 0) {
                        stateClass = 'map-red-bg';
                        stateIconClass = 'icon-parking';
                        label = t("map.sidebar.filtersDevices.parked");
                    }
                    var _noGprs = props.transformDateAndCompare(props.device.gpsInfo.timestampApi);
                    if (_noGprs) {
                        stateClass = 'map-blue-bg';
                        stateIconClass = 'icon-no_gprs';
                        label = t("map.sidebar.filtersDevices.noGprs");
                    }
                }
                listHistoricalData = props.listHistoricalData;
                historicalData = props.historicalData;
                return {
                    stateClass: stateClass,
                    stateIconClass: stateIconClass,
                    label: label,
                    listHistoricalData: listHistoricalData,
                    historicalData: historicalData
                };
            }
        }
    }]);

    return HistoricalDevices;
}(Component);

export default withTranslation()(HistoricalDevices);